import { useSelector } from "react-redux";

const UseDocControlPermissions = () => {
  // Add defensive checks to prevent undefined errors
  const permissions = useSelector(
    (state) => state.projectReducer?.permissions
  ) || {};
  
  const document_control = permissions.document_control || {};

  // Default to true if permissions are not available
  let canView = document_control?.view ?? true;
  let canEdit = true;
  // let canEdit = document_control?.add_edit ?? true;
  // Always set export permission to true regardless of actual permissions
  let canExport = true;
  let canDelete = document_control?.delete ?? true;

  return [canView, canEdit, canExport, canDelete];
};

export default UseDocControlPermissions;
